export enum SearchScopeEnum {
    Undefined = "Undefined",
    Other = "Other",
    Service = "Service",
    Media = "Media",
    Product = "Product"
}
